import { find as _find } from 'lodash';
import { without as _without } from 'lodash';

class AccessoryContainerController {
  constructor(authService, enums, $stateParams, lookupService, loadingService, accessoryManagementService) {
    "ngInject";
    
    this.$stateParams = $stateParams;
    this.lookupService = lookupService;
    this.loadingService = loadingService;
    this.accessoryManagementService = accessoryManagementService;

    this.accessoryLookups = [];
    this.initializeAccessories();

    this.state = '';
    this.resetNotification();
  }

  resetNotification() {
    this.notification = {
      type: '',
      msg: ''
    };
  }

  initializeAccessories() {
    const ctrl = this;

    ctrl.loadingService.showLoading('accessoryList', 'Loading Accessories ...');

    ctrl.lookupService.lookupAccessoryLookups(ctrl.$stateParams.locationId, true)
      .then(accessoryLookups => {
        ctrl.accessoryLookups = accessoryLookups;
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('accessoryList');
      });
  }

  addAccessory() {
    const ctrl = this;

    ctrl.resetNotification();

    if (!ctrl.tempName || ctrl.tempName.length < 3 || ctrl.tempName.length > 40) {
      ctrl.notification = {
        type: 'error',
        msg: 'Name is required field and must be between 3 and 40 characters'
      };

      return;
    }
    else if (_find(ctrl.accessoryLookups, a => a.name === ctrl.tempName)) {
      ctrl.notification = {
        type: 'error',
        msg: `${ctrl.tempName} is already added to the list`
      };

      return;
    }
    else {
      ctrl.accessoryLookups.push({name: ctrl.tempName});
      ctrl.tempName = '';
    }
  }

  removeAccessory(accessory) {
    this.accessoryLookups = _without(this.accessoryLookups, accessory);
  }

  saveChanges() {
    const ctrl = this;

    const accessoryList = ctrl.accessoryLookups.map(a => a.name);

    ctrl.loadingService.showLoading('accessoryList', 'Updating Accessories ...');

    ctrl.accessoryManagementService.updateAccessories(ctrl.$stateParams.locationId, accessoryList)
      .then(response => {
        this.notification = {
          type: 'success',
          msg: 'Accessories updated successfully'
        };
      })
      .catch(err => {
        this.notification = {
          type: 'error',
          msg: 'An error occurred while updating accessories'
        };
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('accessoryList');
      });
  }
}

export default AccessoryContainerController;



// WEBPACK FOOTER //
// ./client/app/components/accessoryManagement/accessoryContainer/accessoryContainer.controller.js